import '@ihme/common/polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-ga4';

import { localStorageAdapter, StorageProvider } from '@ihme/common/packages/storage';
import ThemeProvider from '@ihme/common/theme/ThemeProvider';

import config from './config';
import defaultTheme from './theme/default';
import { init as initLocales } from './locale';

import Router from './router';

TagManager.initialize(config.googleAnalyticsId);

initLocales();

ReactDOM.render(
    <ThemeProvider theme={defaultTheme}>
        <StorageProvider version={config.storageCacheVersion} storageAdapter={localStorageAdapter}>
            <Router />
        </StorageProvider>
    </ThemeProvider>,
    document.getElementById('root')
);
